import { Fastfood, Flag, MoodBad, Star, TagFaces, Waves } from "@clockwise/design-system/icons";
import { SchedulingAttendanceSummaryTag } from "@clockwise/schema";
import React from "react";

export const getFormattedTag = (tags: SchedulingAttendanceSummaryTag[], index: number) => {
  const soloTag = (tags?.length && tags[0]) || "";
  let Icon,
    tagText = soloTag;

  if (
    tags?.includes(SchedulingAttendanceSummaryTag.Soonest) &&
    tags?.includes(SchedulingAttendanceSummaryTag.Best)
  ) {
    Icon = Star;
    tagText = "Soonest & best";
  } else {
    switch (soloTag) {
      case SchedulingAttendanceSummaryTag.Soonest:
        Icon = Flag;
        break;
      case SchedulingAttendanceSummaryTag.Best:
        Icon = Star;
        tagText = "Best pick";
        break;
      case SchedulingAttendanceSummaryTag.MostFocus:
        Icon = Waves;
        tagText = "Most focus";
        break;
      case SchedulingAttendanceSummaryTag.Inconvenient:
      case SchedulingAttendanceSummaryTag.Conflict:
        Icon = MoodBad;
        tagText = soloTag;
        break;
      case SchedulingAttendanceSummaryTag.OverLunch:
        Icon = Fastfood;
        tagText = "Over lunch";
        break;
      case SchedulingAttendanceSummaryTag.InFocusTime:
        Icon = Star;
        tagText = "In Focus Time";
        break;
      case SchedulingAttendanceSummaryTag.Good:
      default:
        // Shouldn't happen
        Icon = index === 1 ? Star : TagFaces;
        tagText = index <= 1 ? "Good pick" : "Also good";
    }
  }

  return {
    full: (
      <div className="cw-flex cw-items-center cw-gap-1">
        <Icon className="cw-w-4 cw-h-4" />
        <span className="cw-truncate">{tagText}</span>
      </div>
    ),
    icon: <Icon className="cw-w-4 cw-h-4" />,
  };
};
